import action from '../commons/consultationActionStatus';

export const getPatientNextConsultationTestRequestAction = (patientId) => {
    return {
        type: action.GET_NEXT_CONSULTATION_SCHEDULE_REQUEST,
        status: 'GET_NEXT_CONSULTATION_SCHEDULE_DETAILS_REQUEST',
        requestState: true,
        payload: {
            patientId
        },
    };
};

export const getPatientNextConsultationTestSuccessAction = (result) => {
    return {
        type: action.GET_NEXT_CONSULTATION_SCHEDULE_SUCCESS,
        status: 'Next consultation test retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getPatientNextConsultationTestFailureAction = (error) => {
    return {
        type: action.GET_NEXT_CONSULTATION_SCHEDULE_FAILURE,
        status: 'Get Next consultation test of patient failure',
        error,
        requestState: false,
    };
};

export const getRecommendedAdditionalTestRequestAction = (consultationId) => {
    return {
        type: action.GET_ADDITIONAL_RECOMMENDED_TEST_REQUEST,
        status: 'GET_ADDITIONAL_RECOMMENDED_TEST_REQUEST',
        requestState: true,
        payload: {
            consultationId
        },
    };
};

export const getRecommendedAdditionalTestSuccessAction = (result) => {
    return {
        type: action.GET_ADDITIONAL_RECOMMENDED_TEST_SUCCESS,
        status: 'Next additional recommended test retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getRecommendedAdditionalTestFailureAction = (error) => {
    return {
        type: action.GET_ADDITIONAL_RECOMMENDED_TEST_FAILURE,
        status: 'Get Next consultation test of patient failure',
        error,
        requestState: false,
    };
}; 

export const getFollowUpTestRequestAction = (consultationId) => {
    return {
        type: action.GET_FOLLOW_UP_TEST_REQUEST,
        status: 'GET_FOLLOW_UP_TEST_REQUEST',
        requestState: true,
        payload: {
            consultationId
        },
    };
};

export const getFollowUpTestSuccessAction = (result) => {
    return {
        type: action.GET_FOLLOW_UP_TEST_SUCCESS,
        status: 'Follow up test retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getFollowUpTestFailureAction = (error) => {
    return {
        type: action.GET_FOLLOW_UP_TEST_FAILURE,
        status: 'Get Follow up test failure',
        error,
        requestState: false,
    };
}; 

export const getConsultationObservationRequestAction = (patientId) => {
    return {
        type: action.GET_CONSULTATION_OBSERVATION_REQUEST,
        status: 'GET_CONSULTATION_OBSERVATION_REQUEST',
        requestState: true,
        payload: {
            patientId
        },
    };
};

export const getConsultationObservationSuccessAction = (result) => {
    return {
        type: action.GET_CONSULTATION_OBSERVATION_SUCCESS,
        status: 'Consultation observation retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getConsultationObservationFailureAction = (error) => {
    return {
        type: action.GET_CONSULTATION_OBSERVATION_FAILURE,
        status: 'Get all Consultation observations failure',
        error,
        requestState: false,
    };
}; 